import styled from 'styled-components';

import {
  colors,
  cssBreakpoints,
  fontWeights,
  h4Text,
  h5Text,
} from 'theme/theme';

export const SearchHitInfoHolder = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;

  /* Leave space for the save search button */
  overflow-wrap: break-word;
`;

export const SearchHitInfoHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
`;

export const SearchHitInfoHeaderHeading = styled.h3`
  ${h4Text};
  line-height: 1.25;
  margin: 0;
`;

export const SearchHitInfoHeaderOrgName = styled.h4`
  ${h5Text};
  color: ${colors.mediumContentGrey};
  font-weight: ${fontWeights.semiBold};
  line-height: 1.375;
  margin: 0;
`;

export const SearchHitInfoStats = styled.div`
  align-items: center;
  color: ${colors.lightContentGrey};
  display: flex;
`;

export const SearchHitInfoPipe = styled.span`
  background: currentcolor;
  display: inline-block;
  height: 16px;
  margin: 4px 8px;
  opacity: 0.33;
  width: 1px;
`;

export const SearchHitInfoFooterHolder = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 10px;
  border-top: 1px solid ${colors.calloutGrey};
  font-size: 12px;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    font-size: 14px;
  }
`;

export const SearchHitInfoFundingMeterHolder = styled.div`
  margin-top: 8px;
`;
